var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 15.05V19.95C18.6666 24.0333 17.0333 25.6667 12.9499 25.6667H8.04992C3.96659 25.6667 2.33325 24.0333 2.33325 19.95V15.05C2.33325 10.9667 3.96659 9.33333 8.04992 9.33333H12.9499C17.0333 9.33333 18.6666 10.9667 18.6666 15.05Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.6666 8.05V12.95C25.6666 17.0333 24.0333 18.6667 19.9499 18.6667H18.6666V15.05C18.6666 10.9667 17.0333 9.33333 12.9499 9.33333H9.33325V8.05C9.33325 3.96667 10.9666 2.33333 15.0499 2.33333H19.9499C24.0333 2.33333 25.6666 3.96667 25.6666 8.05Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.62dae5f93a984a9c747572d4c968fa0e.svg";
export { ForwardRef as ReactComponent };